import { ref } from 'vue'
import { defineStore } from 'pinia'

export const useStore = defineStore('btoscomponent', () => {
  const headerMenu = ref(null)
  const sideMenuList = ref(null)
  const snsList = ref(null)
  const memberMenuList = ref(null)
  const areaPrefList = ref(null)

  return {
    headerMenu,
    sideMenuList,
    snsList,
    memberMenuList,
    areaPrefList
  }
})
